// DeveloperOnly — Sprint messages-section-fixes (D-msg-3).
//
// Gate component. Renders its children only when the global
// `developerMode` setting is enabled. Founder mode (the default) sees
// nothing.
//
// Why it exists: founder-first §3 mandates that every developer-shaped
// surface is hidden by default and revealed only behind the developer
// toggle. Pre-sprint, this rule was applied ad-hoc — a handful of
// components (`ToolCallRow`, `AggregationCard`, the system-message
// filter in `ConversationList`) honoured it, but several others
// (`OrphanToolResult`, `SubagentPanel.<pre>` blocks, `ErrorCard.detail`,
// the `SystemPill` default branch) leaked raw output regardless of the
// toggle. Centralising the gate in this single component makes "is this
// founder-shaped or developer-shaped" a one-line decision and prevents
// the leak class from recurring.
//
// Usage:
//
//   <DeveloperOnly>
//     <pre>{rawJson}</pre>
//   </DeveloperOnly>
//
// The component is intentionally minimal — no fallback prop, no inline
// "click to enable developer mode" CTA. The reveal mechanism lives in
// Settings; the messages section is not the place to advertise it.

import type { ReactNode } from 'react';
import { useSettingsStore } from '../../stores/settings.store';

export interface DeveloperOnlyProps {
  children: ReactNode;
}

export function DeveloperOnly({ children }: DeveloperOnlyProps) {
  const developerMode = useSettingsStore((s) => s.developerMode);
  if (!developerMode) return null;
  return <>{children}</>;
}
